import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import images from '../images/**/*.{jpg,jpeg,png,svg}'
Object.entries(images).forEach(image => image)
